import Modal from './Modal';
import ConfirmationModal from './ConfirmationModal';
import UploadModal from './UploadModal';

export default Modal;
export { ConfirmationModal, UploadModal };
